// List of allowed feature flags
export enum FeatureFlag {
  // TODO Update aiOperator based off ENG-17897 FF
  aiOperator = 'aiOperator',
  attachMediaToIncidentNote = 'attachMediaToIncidentNote',
  camioCameraStream = 'camioCameraStream',
  cannedDashboardBarCartData = 'cannedDashboardBarCartData',
  cannedVideo = 'cannedVideo',
  caseManagement = 'caseManagement',
  dashboardHome = 'dashboardHome',
  dashboardOITableFilters = 'dashboardOITableFilters',
  dashboardOITableIncidentTypeColumn = 'dashboardOITableIncidentTypeColumn',
  deviceHealthSettings = 'deviceHealthSettings',
  emergencyCall = 'emergencyCall',
  guardTours = 'guardTours',
  legacyDashboard = 'legacyDashboard',
  orangePeelCameraStream = 'orangePeelCameraStream',
  orderRepair = 'orderRepair',
  pacsSourceSecrets = 'pacsSourceSecrets',
  salesDatabaseReset = 'salesDatabaseReset',
  manualIncidentCategories = 'manualIncidentCategories',
  incidentRules = 'incidentRules',
  development = 'development',
  llmProcessedIncidents = 'llmProcessedIncidents',
  quickReport = 'quickReport',
  sendToOntic = 'sendToOntic',
  embeddedDashboard = 'embeddedDashboard',
  cameraTestUtil = 'cameraTestUtil', // Utility to Test camera config in Edit Camera modal. This has nothing to do with testing code.
}

type FlagEntries = Array<[FeatureFlag, 'true' | 'false']>

export type Flags = {
  [key in FeatureFlag]?: boolean
}

const parseFlagEntries = (flagEntries: FlagEntries): Flags => {
  const flags = {}
  for (const [name, value] of flagEntries) {
    switch (value) {
      case 'true':
        flags[name] = true
        break
      case 'false':
        flags[name] = false
        break
      default:
        throw new Error(`incorrect value: ${value} for flag ${name}`)
    }
  }
  return flags
}

const flagEntries = process.env.NEXT_PUBLIC_FEATURE_FLAGS
  ? process.env.NEXT_PUBLIC_FEATURE_FLAGS?.split(',').map((flagString) =>
      flagString.split(':')
    )
  : []

const FEATURE_FLAGS = parseFlagEntries(flagEntries as FlagEntries)

export const useFeatureFlag = (flag: FeatureFlag): boolean => {
  return FEATURE_FLAGS?.[flag] || false
}

// TODO - Should be renamed to something like getFeatureFlags?
export const useFeatureFlags = (): Flags => {
  return FEATURE_FLAGS
}

type ProviderType = ({ children }: { children: React.ReactNode }) => JSX.Element

export const flagProvider = (provider: ProviderType, flag: FeatureFlag) => {
  const isEnabled = useFeatureFlag(flag)
  return isEnabled ? provider : ({ children }) => children
}
